import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useCallback, useState, useEffect } from 'react';
import { isTestMode } from '../config/testMode';

export const useRecaptcha = () => {
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [isRecaptchaReady, setIsRecaptchaReady] = useState(false);

    // Monitor when executeRecaptcha becomes available
    useEffect(() => {
        // In test mode, always set as ready
        if (isTestMode()) {
            setIsRecaptchaReady(true);
        } else if (executeRecaptcha) {
            setIsRecaptchaReady(true);
        } else {
            setIsRecaptchaReady(false);
        }
    }, [executeRecaptcha]);

    const executeRecaptchaAction = useCallback(async (action) => {
        // In test mode, return a mock token
        if (isTestMode()) {
            console.log('[TEST MODE] Bypassing reCAPTCHA for action:', action);
            return 'test_recaptcha_token';
        }

        if (!executeRecaptcha) {
            console.warn('reCAPTCHA still loading');
            throw new Error('reCAPTCHA not ready');
        }

        try {
            const token = await executeRecaptcha(action);
            return token;
        } catch (error) {
            console.error('reCAPTCHA execution failed:', error);
            throw new Error('reCAPTCHA verification failed');
        }
    }, [executeRecaptcha]);

    return {
        executeRecaptchaAction,
        isRecaptchaReady: isTestMode() ? true : isRecaptchaReady
    };
};